import {
    Gift,
    MyDevice,
    StoreCredit,
    Subscribe
} from '@components/common/AccountSidebar/icons'
import { TFunction } from 'next-i18next'
export const isGiftCardEnabled = true

export const getStoreLevelTabs = (t: TFunction) => {
    return [
        {
            name: t('account|My Devices'),
            path: '/account/devices',
            class: 'order-icon',
            icon: MyDevice,
            enable: true
        },
        {
            name: t('account||storecredit|Store Credit'),
            path: '/account/store-credit',
            class: 'store-credit-icon',
            icon: StoreCredit,
            enable: true
        },
        {
            name: t('account||giftCard|Gift Card'),
            path: '/account/gift-card',
            class: 'gift-icon',
            icon: Gift,
            enable: isGiftCardEnabled
        }
    ]
}
